import React, { Component } from 'react';
import { Container, Row, Col, Input, InputGroup, InputGroupAddon, Form, FormGroup, FormText, Button } from 'reactstrap'
import { db } from '../firebase'
import AddPlayerForm from '../components/AddPlayerForm.jsx'
// console.log('database',database().ref());
export default (props) => {
  // console.log('LOCATION',props.location);
  return (
          <Row>
            <Col>
              <AddPlayerForm {...props}/>
            </Col>
          </Row>
      )
}



// WEBPACK FOOTER //
// ./src/pages/AddPlayer.jsx